export const CHARGE_TYPE_OPTIONS = [
  { value: null, label: 'Todos' },
  { value: 'SINGLE', label: 'Simples' },
  { value: 'RECURRING', label: 'Recorrentes' },
  { value: 'INSTALLMENT', label: 'Parceladas' },
];

export default CHARGE_TYPE_OPTIONS;
